/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxButtonComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxbuttons';

/**
 * Button
 */

export class NgcButtonComponent extends ControlComponent {
     delay: any;
     imgSrc: any;
     imgWidth: any;
     imgHeight: any;
     imgPosition: any;
     roundedCorners: any;
     rtl: any;
     textPosition: any;
     textImageRelation: any;
     theme: any;
     template: any;
     toggled: any;
     value: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-button',
    template: `<jqxButton *ngIf="visible"
                [delay] = "delay"
                [disabled] = "disabled"
                [imgSrc] = "imgSrc"
                [imgWidth] = "imgWidth"
                [imgHeight] = "imgHeight"
                [imgPosition] = "imgPosition"
                [roundedCorners] = "roundedCorners"
                [rtl] = "rtl"
                [textPosition] = "textPosition"
                [textImageRelation] = "textImageRelation"
                [theme] = "theme"
                [template] = "template"
                [toggled] = "toggled"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxButton>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'delay': [{ type: Input, args: ['delay', ] },],
'imgSrc': [{ type: Input, args: ['imgSrc', ] },],
'imgWidth': [{ type: Input, args: ['imgWidth', ] },],
'imgHeight': [{ type: Input, args: ['imgHeight', ] },],
'imgPosition': [{ type: Input, args: ['imgPosition', ] },],
'roundedCorners': [{ type: Input, args: ['roundedCorners', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'textPosition': [{ type: Input, args: ['textPosition', ] },],
'textImageRelation': [{ type: Input, args: ['textImageRelation', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'template': [{ type: Input, args: ['template', ] },],
'toggled': [{ type: Input, args: ['toggled', ] },],
'value': [{ type: Input, args: ['value', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Button Module
 */

export class NgcButtonModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcButtonComponent],
    declarations: [NgcButtonComponent, jqxButtonComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
